import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWindows = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_33117_17412)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0.03125 2.26347L6.54456 1.3765L6.54736 7.65908L0.0371644 7.69612L0.03125 2.26353V2.26347ZM6.54144 8.38288L6.54643 14.6709L0.0362928 13.7759L0.0359193 8.34073L6.54144 8.38288ZM7.33099 1.26039L15.967 0V7.57914L7.33099 7.64763V1.26039ZM15.969 8.44202L15.9669 15.987L7.33092 14.7681L7.31885 8.42789L15.969 8.44202Z",
			fill: "#00ADEF"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_33117_17412",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgWindows;
